/* eslint-disable no-plusplus */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Svg } from 'app/components/common';
import { Constants } from 'app/utilities';
import { logButtonClick } from 'app/events/Events';
import * as buttonActions from 'app/events/buttonActions';
import * as LogClevertapEvent from 'clevertap/LogEvent';
import { getCDNImageUrl, getSeoShopUrl } from 'app/utilities/Utils';
import CustomImage from 'app/components/common/CustomImage';
import { STOREPAGE, STORECATEGORYPAGE } from '../../events/screens';
import StoreSocialShare from './StoreSocialShare';
import '../../styles/stores/stores.scss';
import 'app/styles/shimmer/Shimmer.scss';

const ShopCard = ({
  item, language, screen, history, toggleSideOverlay,
}) => {
  const rating = parseFloat(item.rating);
  const distanceString = item.calculatedDistanceMeasurement === 'meters'
    ? `${parseFloat(item.calculatedDistance / 1000).toFixed(2)}Kms`
    : `${item.calculatedDistance}${item.calculatedDistanceMeasurement}`;
  const pickupOnlyAllowed = (
    !item?.productTransferMode.homeDelivery
    && item?.productTransferMode.storePickup
  );
  const { hasSeoData, shopUrl } = getSeoShopUrl(
    item.country || '',
    item.city || '',
    item.locality || '',
    item.storeType.name || '',
    item.name || '',
    item.storeId || '',
  );
  let renderedTags = 0;
  return (
    <Col
      xs={24}
      md={12}
      className="mx-0 px-2 overflow-hidden store py-3"
    >
      <Row
        className={`${item.isFreeSample ? 'shimmer_border' : 'border-light border'} 
           mx-0 bg-white border-radius-16 h-100 overflow-hidden position-relative`}
      >
        <Col className="d-flex flex-grow-1 flex-column justify-content-space-between">
          <Row
            as={hasSeoData
              ? Link
              : 'div'}
            to={shopUrl}
            onClick={() => {
              logButtonClick(
                {
                  BUTTON: buttonActions.VIEW_DETAILS,
                  SCREEN: screen,
                  STORE_ID: item.storeId,
                  STORE_NAME: item.name,
                },
              );
              LogClevertapEvent.shopCardshopClicked(STOREPAGE, item.storeTypeName);
              if (!hasSeoData) {
                history.push(shopUrl);
              }
            }}
            className=" bg-white text-dark d-flex flex-nowrap cursor-pointer"
          >
            <Col
              xs="auto"
              className="px-0 py-4 mx-2"
            >
              <CustomImage
                imageStyle="store-image"
                imageUrl={getCDNImageUrl(item.logo)}
                imageAlt={item.name}
                imageTitle={item.name}
                imageType="STORE"
              />
            </Col>
            <Col
              className="px-1 py-2 fs-5 "
            >
              <h4
                className="r__store_title"
                title={item.name}
              >
                {item.name}
              </h4>
              <div
                className="mb-2 mt-2 text-medium"
              >
                {item.storeType.name}
              </div>
              <Row
                className="ml-0 mb-2 d-inline-flex overflow-hidden r__flex-5"
              >
                {item.isFreeSample && renderedTags < 2
                  && (
                    renderedTags++,
                      <div>
                        <Svg
                          svg="freeSample"
                          width="89px"
                          height="26px"
                        />
                      </div>
                  )}
                {item.isPremium && renderedTags < 2
                  && (
                    renderedTags++,
                      <div>
                        <Svg
                          svg="premium"
                          width="74px"
                          height="20px"
                        />
                      </div>
                  )}
                {item.isTrending && renderedTags < 2
                  && (
                    renderedTags++,
                      <div className="">
                        <Svg
                          svg="trending"
                          width="71px"
                          height="20px"
                        />
                      </div>
                  )}
                {item.isGreatOffer && renderedTags < 2
                  && (
                    renderedTags++,
                      <div className="">
                        <Svg
                          svg="greatOffers"
                          width="81px"
                          height="20px"
                        />
                      </div>
                  )}
                {item.isWideVariety && renderedTags < 2
                  && (
                    renderedTags++,
                      <div className="">
                        <Svg
                          svg="wideVariety"
                          width="86px"
                          height="21px"
                        />
                      </div>
                  )}
                {item.isBestRated && renderedTags < 2
                  && (
                    renderedTags++,
                      <div className="">
                        <Svg
                          svg="bestRated"
                          width="80px"
                          height="20px"
                        />
                      </div>
                  )}
                {item.isNewlyOpened && renderedTags < 2
                  && (
                    renderedTags++,
                      <div className="">
                        <Svg
                          svg="storeNew"
                          width="43px"
                          height="20px"
                        />
                      </div>
                  )}
              </Row>
              <Row
                className="mx-0 mb-2 align-items-center "
              >
                {!!rating && (
                  <Col
                    xs="auto"
                    className="pl-0 pr-2 d-flex align-items-center"
                  >
                    <Svg
                      svg="newStar"
                      height="14"
                      width="14"
                    />
                    <span
                      className="px-1 text-normal font-weight-bold"
                    >
                      {rating || '--'}
                    </span>
                    <span className="text-medium">
                      {'\u2022'}
                    </span>
                  </Col>
                )}
                {
                  pickupOnlyAllowed
                    ? Constants.String.SHOP_PICKUP_ONLY[language]
                    : (
                      <>
                        <Svg
                          svg="vehical"
                          height="16"
                          width="16"

                        />
                        <span
                          className="px-1 text-normal font-weight-bold"
                        >
                          {item.averageDeliveryTimeString}
                        </span>
                      </>
                    )
                }
              </Row>
              <Row
                className="px-3 pb-2 mb-2 text-medium"
              >
                {distanceString && (<span className="px-1">{distanceString}</span>)}
                {item.locality && (
                <>
                  {'\u2022'}
                  <span className="px-1">{item.locality.charAt(0).toUpperCase() + item.locality.slice(1)}</span>
                </>
                )}
              </Row>
            </Col>
          </Row>
          <div className="share-bg">
            <Button
              className="share_button"
              onClick={() => {
                toggleSideOverlay(() => (
                  <StoreSocialShare
                    language={language}
                    isMobile
                    storeDetails={item}
                  />
                ), true, false, true);
                LogClevertapEvent.shopCardShareClicked(STORECATEGORYPAGE, item.storeType.name);
              }}
            >
              <Svg
                svg="shareButton"
              />
            </Button>
          </div>
          <Row
            className={`${item.isFreeSample ? 'bg-green' : 'bg-yellow'} d-flex align-items-center fs-5 justify-content-center px-2 py-2`}
          >
            <Col
              xs="auto"
              className="pl-2 pr-0"
            >
              {item.isFreeSample
                ? (
                  <Svg
                    svg="clock"
                    width="25px"
                    height="25px"
                    fill={Constants.Color.white}
                    stroke={Constants.Color.white}
                    stroke1={Constants.Color.green}
                  />
                )
                : (
                  <Svg
                    svg="graphicOffer"
                    width="1.5rem"
                    circleFill={Constants.Color.white}
                    pathFill={Constants.Color.black}
                  />
                )}
            </Col>
            <Col className={`${item.isFreeSample ? 'text-white pl-1 pr-0 mr-0 shimmer' : 'px-1 text-black shop-text-truncate'} font-weight-bold`}>
              {
                item.isFreeSample
                  ? (
                    <div className="d-flex pr-0">
                      <span className="font-weight-black fs-5">
                        {Constants.String.FREE_SAMPLE_STR[language]}
                      </span>
                      <span className="pl-8 mx-0 font-weight-black fs-5">
                        {Constants.String.TC_STR[language]}
                      </span>
                    </div>
                  )
                  : item.offerText
              }
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

ShopCard.propTypes = {
  item: PropTypes.shape({
    storeId: PropTypes.string,
    name: PropTypes.string,
    distanceString: PropTypes.string,
    averageDeliveryTimeString: PropTypes.string,
    isDelivering: PropTypes.bool,
    isPremium: PropTypes.bool,
    calculatedDistanceMeasurement: PropTypes.string,
    calculatedDistance: PropTypes.number,
    isTrending: PropTypes.bool,
    isVerified: PropTypes.bool,
    isFavorite: PropTypes.bool,
    isBestRated: PropTypes.bool,
    isWideVariety: PropTypes.bool,
    isNewlyOpened: PropTypes.bool,
    isGreatOffer: PropTypes.bool,
    isFreeSample: PropTypes.bool,
    nextOnlineTime: PropTypes.string,
    freeSampleExpiryDate: PropTypes.string,
    offerText: PropTypes.string,
    rating: PropTypes.string,
    logo: PropTypes.string,
    productTransferMode: PropTypes.shape({
      homeDelivery: PropTypes.bool,
      storePickup: PropTypes.bool,
    }),
    storeTypeName: PropTypes.string,
    storeType: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
    }),
    locality: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
  }).isRequired,
  language: PropTypes.string.isRequired,
  screen: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  toggleSideOverlay: PropTypes.func.isRequired,
};

export default ShopCard;
